import { faExternalLink } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Images } from '../../../assets';
import { AtiraIcon } from '../../../components/AtiraIcon';
import { Blog } from '../../../components/Blog';
import { Flex } from '../../../components/Flex';
import { AtiraImage } from '../../../components/Image';
import { SpinnerFullScreen } from '../../../components/SpinnerFullScreen';
import { blogsSliceSelectors } from '../../../redux/blogs/blogs.selector';
import { useAppSelector } from '../../../redux/store';
import { FontSize } from '../../../theme/FontSize';
import { Rounded } from '../../../theme/Rounded';
import { Spacing } from '../../../theme/Spacing';

const MoreArticlesLink = styled.a`
  background-color: ${({ theme }) => theme.main};
  color: ${({ theme }) => theme.onMain};
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${Spacing.s};
  padding: ${Spacing.s};
  font-size: ${FontSize.m};
  width: 100%;
  text-align: center;
  border-radius: ${Rounded.md};
  transition: all 0.3s;

  margin-top: ${Spacing.l};

  &:hover {
    background-color: ${({ theme }) => theme.mainHover};
    color: ${({ theme }) => theme.onMain};
  }
`;

const Container = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${Spacing.xxxl};
  padding-inline: ${Spacing.s};
`;

export const NotificationsBlogTab: React.FC = () => {
  const { t } = useTranslation();

  const blogs = useAppSelector(blogsSliceSelectors.selectBlogs);
  const blogsLoading = useAppSelector(blogsSliceSelectors.selectBlogsLoading);

  return (
    <Container>
      {!blogsLoading ? (
        <Flex flexDirection="column" alignItems="center">
          <Flex flexDirection="column" alignItems="center" gap="m">
            {blogs.map((p) => (
              <Blog post={p} key={p.id} />
            ))}
          </Flex>
          <MoreArticlesLink
            href="https://atiragrup.com/category/atira-blog/atira-link/"
            target="_blank"
          >
            <AtiraIcon icon={faExternalLink} />
            {t('bell.drawer.articles.more')}
          </MoreArticlesLink>
        </Flex>
      ) : (
        <SpinnerFullScreen />
      )}

      <AtiraImage src={Images.AtiraLinkMainLogo} width="70%" />
    </Container>
  );
};
